import {
  DraftAccountDTO,
  ESigned,
  FormValues,
  InvestmentObjective,
  IsPoliticallyExposed,
  LiquidityNeeds,
  TimeHorizon,
} from '../AccountOpening.meta';
import { dobToForm } from '../fields/DateOfBirth/DateOfBirth.meta';
import { stateToForm } from '../fields/Address/Address.meta';
import { employmentStatusToForm } from '../fields/EmploymentStatus/EmploymentStatus.meta';
import { nullTrustedContactInfo } from '../fields/TrustedContact/TrustedContact.meta';
import { nullInterestedPartyInfo } from '../fields/InterestedParty/InterestedParty.meta';
import { nullBeneficiaryInfo } from '../fields/Beneficiary/Beneficiary.meta';

export const draftToForm = (draftAccount: DraftAccountDTO): FormValues => ({
  primaryApplicant: {
    ...draftAccount.primaryApplicant,
    dob: dobToForm(draftAccount.primaryApplicant.dob),
    state: stateToForm(draftAccount.primaryApplicant.state),
    employmentStatus: employmentStatusToForm(draftAccount.primaryApplicant.employmentStatus),
  },

  secondApplicant: {
    ...draftAccount.secondApplicant,
    dob: dobToForm(draftAccount.secondApplicant.dob),
    state: stateToForm(draftAccount.secondApplicant.state),
    employmentStatus: employmentStatusToForm(draftAccount.primaryApplicant.employmentStatus),
  },

  retirementAccountBeneficiaryInfo: draftAccount.retirementAccountBeneficiaryInfo
    ? {
        hasBeneficiary: true,
        ...draftAccount.retirementAccountBeneficiaryInfo,
        dateOfBirth: dobToForm(draftAccount.retirementAccountBeneficiaryInfo.dateOfBirth),
      }
    : { hasBeneficiary: false, ...nullBeneficiaryInfo },

  isControlPerson: draftAccount.isControlPerson || false,
  companySymbols: draftAccount.companySymbols ? draftAccount.companySymbols[0] : '',

  isCustodianEmployee: draftAccount.isCustodianEmployee || false,

  isAffiliatedExchangeOrFINRA: draftAccount.isAffiliatedExchangeOrFINRA || false,
  brokerDealerfirmName: draftAccount.brokerDealerfirmName,
  snapId: draftAccount.snapIds.length > 0 ? draftAccount.snapIds[0] : null,

  isPoliticallyExposed: draftAccount.isPoliticallyExposed === IsPoliticallyExposed.Yes,
  immediateFamily: draftAccount.immediateFamily,
  politicalOrganization: draftAccount.politicalOrganization,

  liquidityNeeds: draftAccount.liquidityNeeds ?? LiquidityNeeds.SomewhatImportant,

  timeHorizon: draftAccount.timeHorizon ?? TimeHorizon.Average,

  riskTolerance: draftAccount.riskTolerance,

  investmentExperience: draftAccount.investmentExperience,

  investmentObjective: draftAccount.investmentObjective ?? InvestmentObjective.Growth,

  trustedContactInfo: draftAccount.trustedContactInfo
    ? { hasTrustedContact: true, ...draftAccount.trustedContactInfo, country: 'USA' }
    : { hasTrustedContact: false, ...nullTrustedContactInfo, country: 'USA' },

  interestedPartyInfo: draftAccount.interestedPartyInfo
    ? { hasInterestedParty: true, ...draftAccount.interestedPartyInfo, country: 'USA' }
    : { hasInterestedParty: false, ...nullInterestedPartyInfo, country: 'USA' },

  eSigned: draftAccount.eSigned !== null ? draftAccount.eSigned === ESigned.Yes : null,
});
